<template>
    <div>
        <div>
            <div class="flex items-center mb-24">
                <div class="w-64 h-64">
                    <img :src="booster.icon" :alt="`${booster.name}-logo`">
                </div>
                <div class="flex flex-col content-start ml-24">
                    <p class="text-heading-2 font-semibold ml-24 mr-24 mb">{{ booster.title[locale] }}</p>
                    <div class="flex items-center ml-24">
                        <svg-icon v-if="booster.media['google']" type="google" class="w-16 h-16 mr-5" />
                        <img v-if="booster.media.instagram" src="/app/img/instagram.svg" alt="Instagram" class="w-16 h-16 mr-5">
                        <svg-icon  v-if="booster.media['facebook-large']" type="facebook" class="w-16 h-16 mr-5" />
                    </div>
                </div>
            </div>
            <p v-html="booster.description[locale]"></p>
        </div>
        <div class="border-t mt-24 mb-16"></div>
        <div>
            <div class="flex my-16">
                <div class="min-w-140 mr-24">
                    <label class="text-body font-semibold">{{ $t('general.duration_days') }}</label>
                    <p>{{ booster.duration }}</p>
                </div>
                <div class="min-w-140 mr-24 shrink-0">
                    <label class="text-body font-semibold">{{ $t('general.price') }}</label>
                    <p class="flex mr-4">
                        <currency :icon="false" />{{ booster.price }}
                    </p>
                </div>
            </div>
            <div class="flex justify-end">
                <a v-if="booster.vacancyCount" href="#" class="text-secondary mr-16 content-center">
                    {{ `${$t('multi-posting.job-boards.view_vacancies')} (${booster.vacancyCount})` }}
                </a>
                <simple-button
                    v-if="isSelectedItem(booster)"
                    display="danger"
                    @click="removeFromCampaign(booster)"
                >
                    {{ $t('multi-posting.campaigns.form.remove_from_campaign') }}
                </simple-button>
                <simple-button
                    v-else
                    display="secondary"
                    look="primary"
                    @click="addToCampaign(booster)"
                >
                    {{ $t('multi-posting.contracts.index.add_to_campaign') }}
                </simple-button>
            </div>

        </div>
    </div>
</template>

<script>
import SimpleButton from "../ui/SimpleButton.vue";
import Currency from '../Currency.vue';
import {mapActions, mapState} from "pinia";
import {useMainStore} from '../../state/store';
import {useMultiPostingStore} from '../../state/modules/multiPosting';
import SvgIcon from "../ui/SvgIcon.vue";

export default {
    name: 'BoosterDetails',
    components: {SimpleButton, Currency, SvgIcon},
    props: {
        booster: {
            type: Object,
            required: true
        },
        campaignHandler: {
            type: Function,
            default: null
        }
    },
    computed: {
        ...mapState(useMultiPostingStore, ['selectedItems']),
        ...mapState(useMainStore, ['locale']),
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['removeSelectedItemById', 'addSelectedItems']),
        addToCampaign(booster) {
            // If we pass a custom campaign handler, we call it instead of adding the booster to the campaign.
            if (this.campaignHandler) {
                this.campaignHandler(booster);
                return;
            }

            this.addSelectedItems([{
                id: booster.id,
                name: booster.title[this.locale],
                duration: {
                    period: booster.duration
                },
                price: {
                    amount: booster.price,
                    currency: 'EUR'
                },
                type: 'socialChannel',
            }]);
            this.$emit('added');
        },
        isSelectedItem(booster) {
            return this.selectedItems.filter(x => x.id == booster.id).length > 0;
        },
        removeFromCampaign(booster) {
            this.removeSelectedItemById({itemId: booster.id});
        },
    },
}
</script>
